export default __webpack_public_path__ + "static/char-s-49-ko-99ca2a025ab1ce1a1923391d9793ce50.png";